import React from "react";
import "./Timeline.css";

export interface TimelineEntry {
  title: string;
  subtitle?: string;
  dateRange?: string;
  badge?: string;
  badgeAccent?: "green" | "amber" | "red" | "neutral";
  bullets?: string[];
}

interface TimelineProps {
  entries: TimelineEntry[];
  emptyText?: string;
}

const Timeline: React.FC<TimelineProps> = ({ entries, emptyText = "No timeline data available." }) => {
  if (!entries || entries.length === 0) {
    return <div className="js-timeline-empty">{emptyText}</div>;
  }

  return (
    <div className="js-timeline">
      {entries.map((entry, i) => (
        <div key={i} className="js-timeline-item">
          <div className="js-timeline-marker">
            <span className="js-timeline-dot" />
          </div>
          <div className="js-timeline-content">
            <div className="js-timeline-head">
              <div className="js-timeline-title">{entry.title}</div>
              {entry.badge && (
                <span className={`js-timeline-badge ${entry.badgeAccent || "neutral"}`}>{entry.badge}</span>
              )}
            </div>
            {entry.subtitle && <div className="js-timeline-subtitle">{entry.subtitle}</div>}
            {entry.dateRange && <div className="js-timeline-dates">{entry.dateRange}</div>}
            {entry.bullets && entry.bullets.length > 0 && (
              <ul className="js-timeline-bullets">
                {entry.bullets.map((b, j) => (
                  <li key={j}>{b}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;